module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-modal', {
    attrs: {
      "open": _vm.refreshPasswordOpened,
      "title": 'Verify Identity',
      "modal-name": _vm.modalName,
      "save": _vm.save,
      "backdrop": false
    },
    on: {
      "closed": function($event) {
        return _vm.closeModal()
      },
      "valid": function($event) {
        return _vm.setFormValid(true)
      },
      "invalid": function($event) {
        return _vm.setFormValid(false)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('xm-input', {
    attrs: {
      "type": "password",
      "label": "Password",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d6a6015","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/RefreshPasswordModal.vue
// module id = 1333
// module chunks = 16